const AJXLoader = () => {
  return (
    <div className="container p-2">
      <div className="hero">
        <div className="px-4 py-5 my-5 text-center">
          <h3 className="display-5">
            <div className="spinner-grow text-primary" role="status"></div>{" "}
            <span>Please wait...</span>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default AJXLoader;
